import React from 'react';
import cn from 'classnames';
import type { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';
import Icon from 'tbk-components/src/components/Icon';
import Image, { IImage } from 'tbk-components/src/components/Image';
export interface IAlternatingTextAndImageItems {
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Image Position
	 */
	imagePosition: 'auto' | 'left' | 'right';
	/**
	 * Image
	 */
	image?: IImage;
	/**
	 * Content
	 * @control richtext
	 */
	content?: string;
	/**
	 * Button link
	 */
	buttonLink?: ILink;
	/**
	 * Arrow link
	 */
	arrowLink?: ILink;
}

export interface IAlternatingTextAndImageProps extends IBaseElementProps {
	/**
	 * Items
	 */
	contentRows?: IAlternatingTextAndImageItems[];
	inverted?: boolean;
}

/**
 * Calian Alternating Text And Images
 * @icon image-flip-horizontal
 * @block
 */
const AlternatingTextAndImage: React.FC<IAlternatingTextAndImageProps> = ({
	id,
	contentRows = [],
	className,
	classNames = [],
	inverted = false,
}) => (
	<div
		id={id}
		className={
			className ||
			cn(
				'calian-alternating-text-and-images overflow-hidden',
				...classNames,
				inverted && 'inverted',
			)
		}
	>
		<div className="calian-alternating-text-and-images__container container-fluid">
			{contentRows.length > 0 && (
				<div className="">
					{contentRows.map(
						(
							{
								imagePosition,
								image,
								heading,
								content,
								buttonLink,
								arrowLink,
							},
							index,
						) => (
							<div
								className={cn(
									'row gx-md-6',
									(!imagePosition ||
										imagePosition === 'auto') &&
										index % 2 !== 0
										? 'flex-row-reverse justify-content-lg-between'
										: 'justify-content-lg-start',
									imagePosition &&
										imagePosition != 'auto' &&
										imagePosition === 'right'
										? 'flex-row-reverse justify-content-lg-between'
										: 'justify-content-lg-start',
									index === contentRows.length - 1
										? ''
										: 'mb-3 mb-md-9',
								)}
								key={index}
							>
								<div className="col-12 col-md mb-3">
									<Image
										{...image}
										className="rounded-5 img-fluid w-100 h-250px h-md-373px object-fit-cover"
									/>
								</div>
								<div className="col-12 col-md">
									{heading && <h3>{heading}</h3>}
									{content && (
										<div
											className="calian-alternating-text-and-images__text mb-3"
											dangerouslySetInnerHTML={{
												__html: content,
											}}
										/>
									)}
									<div className="calian-alternating-text-and-images__ctas mb-3 d-flex flex-wrap gap-3">
										{(buttonLink?.href ||
											buttonLink?.label) && (
											<Button
												{...buttonLink}
												className={cn(
													`btn btn-${
														inverted
															? 'secondary'
															: 'primary'
													}`,
												)}
											/>
										)}
										{arrowLink &&
											(arrowLink?.href ||
												arrowLink?.label) &&
											arrowLink?.label !== '<br>' && (
												<a
													href={arrowLink.href}
													className="calian-alternating-text-and-images__link d-inline-flex align-items-center text-decoration-none"
													style={{ gap: '0.25rem' }}
													target={arrowLink.target}
													rel="noopener noreferrer"
												>
													<span className="d-block">
														{arrowLink.label}
													</span>

													<Icon name="arrow-right" />
												</a>
											)}
									</div>
								</div>
							</div>
						),
					)}
				</div>
			)}
		</div>
	</div>
);

export default AlternatingTextAndImage;
